import { Icons } from "@/assests";

export const jobCategories = [
  {
    title: "Lễ tân nhân sự",
    jobCount: "80",
    icon: Icons[0].letan,
  },
  {
    title: "Quản lý kế toán nhân sự",
    jobCount: "120",
    icon: Icons[1].ketoan,
  },
  {
    title: "Công đoàn trợ lý giám đốc",
    jobCount: "150",
    icon: Icons[2].trolygiamdoc,
  },
  {
    title: "Thư ký/Hành chính",
    jobCount: "100",
    icon: Icons[3].thuky,
  },
  {
    title: "Giám sát bán hàng",
    jobCount: "170",
    icon: Icons[4].banhang,
  },
  {
    title: "Trưởng phòng nhân sự",
    jobCount: "90",
    icon: Icons[5].nhansu,
  },
  {
    title: "Chuyên viên marketing",
    jobCount: "110",
    icon: Icons[6].marketing,
  },
  {
    title: "Quản lý dự án",
    jobCount: "130",
    icon: Icons[7].quanlyduan,
  },
  {
    title: "Nhân viên chăm sóc khách hàng",
    jobCount: "200",
    icon: Icons[8].chamsoc,
  },
  {
    title: "Lao động phổ thông",
    jobCount: "50",
    icon: Icons[9].ldpt,
  },
];
